import Stack from '@careguide/stack'
import { Box, ContentBlock } from '@careguide/theme'
import { createGlobalStyle } from 'styled-components'

import PageLayout from './PageLayout'
import SettingsMenu from 'components/Settings/SettingsMenu'
import { BusinessModelEnum } from 'graph/globalTypes'

const SettingsPageLayout = ({ children, ...pageLayoutProps }) => {
  const { viewer } = pageLayoutProps

  const businessModel = viewer.site.businessModel
  const userType = viewer.user.userType
  const emailDigest = viewer.user.emailDigest
  const hideSubscriptionTab =
    userType === 'provider' && businessModel === BusinessModelEnum.ACTIVE_JOBS
  pageLayoutProps.hasFooter = false

  return (
    <>
      <GlobalStyle />
      <PageLayout {...(pageLayoutProps as any)}>
        <ContentBlock
          bg='gray.0'
          paddingX={{ _: '4', tablet: '5', desktop: '6' }}
          paddingY={{ _: '5', desktop: '6' }}
          maxWidth='1207px'
        >
          <Stack
            direction={{ _: 'vertical', desktop: 'horizontal' }}
            gap={{ _: '0', desktop: '7' }}
          >
            <SettingsMenu hideSubscriptionTab={hideSubscriptionTab} emailDigest={emailDigest} />
            <Box
              display='flex'
              flexGrow={1}
              flexBasis={{ _: '100%', desktop: 'max-content' }}
              flexDirection='column'
            >
              <Stack gap='4'>{children}</Stack>
            </Box>
          </Stack>
        </ContentBlock>
      </PageLayout>
    </>
  )
}

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #f2f2f2;  
  }
`

export default SettingsPageLayout
